import onInit from "../utils/onInit";
import Cookies from 'js-cookie';

const COOKIE_CONSENT_NAME = 'a-cookies-consented';

onInit(() => {
  const cookieBannerEl = document.querySelector('#a-cookie-banner');
  if (!cookieBannerEl) return;

  const cookieConsentBtn = cookieBannerEl.querySelector('button');

  if (Cookies.get(COOKIE_CONSENT_NAME)) return;

  cookieBannerEl.classList.add('d-block');
  cookieConsentBtn.addEventListener('click', (e) => {
    Cookies.set(COOKIE_CONSENT_NAME, '1');
    cookieBannerEl.classList.remove('d-block');
  })
})
